module.exports = __webpack_public_path__ + "img/undraw_Co_workers_re_1i6i.ad48a43a.svg";